import Vue from 'vue'
import Auth from '../core'
import { version } from '@websanova/vue-auth/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.auth = Auth
Vue.$app.auth.version = version
